/**
 * 模块和菜单栏图标的映射
 * 这个关系放在这，不放在mockMenu中，为后续菜单配置从服务端获取提供便利
 * 需要保证每个dataType都对应一个Icon type，即使是二级目录，因为允许修改mockMenu.js来
 * 修改目录都层级关系，二级目录有机会成为一集目录，一集目录需要Icon
 */

const MenuIcons = {
	'commodity-manage': 'shangpinguanliicon',          // 商品管理
	'order-management': 'interation-fill',             // 订单管理
	'comment-manage': 'pinglunguanli_icon',            // 评论管理
	'promotion-payment': 'gift-fill',                  // 营销活动
	'marketing-activity': 'gift-fill',                 // 营销活动
	'settlement-manage': 'file-text-fill',             // 账户信息
	'trade-dashboard': 'home-fill',             			 // 交易概览
	'device-manage': 'setting-fill',                   // 设备管理
	'staff-manage': 'dianyuanguanli_icon',             // 店员管理
	'shop-manage': 'shop-fill',                        // 门店设置
	'shop-approve': 'store-manage-fill',               // 商城设置
	'mall-setting': 'shop-fill',                       // 门店设置
};

export default MenuIcons;
